<template>
  <div class="p-2 border-top">
    <b-row class="mb-1 text-center" v-if="Object.keys(user).length > 0">
      <b-col>
        <small class="font-weight-bold"
          >Usuário adicionado em
          {{ user.createdAt | moment("DD [de] MMM [de] YYYY") }}</small
        >
      </b-col>
    </b-row>
    <div class="w-100 d-flex flex-row" :class="'justify-content-between'">
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        :variant="'outline-success'"
        class="mr-2"
        @click="$emit('form-submit')"
        >Salvar
      </b-button>
      <b-button
        v-ripple.400="'rgba(186, 191, 199, 0.15)'"
        @click="$emit('hide')"
        variant="outline-warning"
        class="float-right"
      >
        Cancelar
      </b-button>
    </div>
  </div>
</template>

<script>
import { BButton, BRow, BCol } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";

export default {
  components: {
    BButton,
    BRow,
    BCol,
  },

  directives: {
    Ripple,
  },

  props: {
    user: {
      type: Object,
      require: true,
    },
  },
};
</script>
